import parseJson from 'json-parse-better-errors'

// Improve type definition to be more specific about return type
type JSONValue = string | number | boolean | null | { [key: string]: JSONValue } | JSONValue[]

const safeJSONParse = (str: string, respondWithOnFail: any = false): JSONValue | false => {
  if (typeof str !== 'string') {
    return respondWithOnFail
  }
  try {
    const jsonReturn = parseJson(str)
    return jsonReturn
  } catch (error) {
    return respondWithOnFail
  }
}

export default safeJSONParse